<div class="ai-models-page">
  <div class="dashboard-body-top">
    <div class="fl-l big-title">
      {{ "SUB-NAVIGATION.AI_MODELS" | translate }}
    </div>
    <div class="fl-r">
      <div class="btn white-bg" (click)="openCreate()">
        <i class="icon-plus-1"></i>
        {{ "GENERALS.ADD" | translate }}
      </div>
    </div>
    <div class="clear"></div>
  </div>

  <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>

  <table mat-table [dataSource]="models" class="ai-models-table">
    <ng-container matColumnDef="provider">
      <th mat-header-cell *matHeaderCellDef>
        {{ "GENERALS.PROVIDER" | translate }}
      </th>
      <td mat-cell *matCellDef="let m">{{ m.provider }}</td>
    </ng-container>

    <ng-container matColumnDef="modelId">
      <th mat-header-cell *matHeaderCellDef>
        {{ "AI_TOKENS.MODEL_ID" | translate }}
      </th>
      <td mat-cell *matCellDef="let m">
        <code>{{ m.modelId }}</code>
      </td>
    </ng-container>

    <ng-container matColumnDef="inputPrice">
      <th mat-header-cell *matHeaderCellDef>
        {{ "AI_TOKENS.INPUT_PRICE_M" | translate }}
      </th>
      <td mat-cell *matCellDef="let m">
        {{ centsToDollars(m.inputPricePerMillionCents) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="outputPrice">
      <th mat-header-cell *matHeaderCellDef>
        {{ "AI_TOKENS.OUTPUT_PRICE_M" | translate }}
      </th>
      <td mat-cell *matCellDef="let m">
        {{ centsToDollars(m.outputPricePerMillionCents) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="active">
      <th mat-header-cell *matHeaderCellDef>
        {{ "GENERALS.ACTIVE" | translate }}
      </th>
      <td mat-cell *matCellDef="let m">
        <mat-slide-toggle
          [checked]="m.active"
          (change)="toggleActive(m)"
        ></mat-slide-toggle>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let m">
        <button
          mat-icon-button
          (click)="openEdit(m)"
          [attr.aria-label]="'GENERALS.EDIT' | translate"
        >
          <mat-icon>edit</mat-icon>
        </button>
        <button
          mat-icon-button
          (click)="delete(m)"
          [attr.aria-label]="'GENERALS.DELETE' | translate"
          color="warn"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
